module.exports = __webpack_public_path__ + "img/aaa.32745e0e.jpg";